import React from 'react';
import { FaWhatsapp, FaLinkedin, FaEnvelope } from 'react-icons/fa';
import './Contact.css';

const Contact = () => {
  const contactMethods = [
    {
      icon: <FaWhatsapp />,
      title: 'WhatsApp',
      description: 'Chat with us instantly',
      link: 'https://wa.me/919959019781',
      color: '#25D366',
      buttonText: 'Message on WhatsApp'
    },
    {
      icon: <FaLinkedin />,
      title: 'LinkedIn',
      description: 'Connect with us professionally',
      link: 'https://www.linkedin.com/in/sunanth-samala-818b2b169?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app',
      color: '#0077B5',
      buttonText: 'Connect on LinkedIn'
    },
    {
      icon: <FaEnvelope />,
      title: 'Email',
      description: 'Send us an email',
      link: 'mailto:sunanth.samala7@gmail.com',
      color: '#EA4335',
      buttonText: 'Send Email'
    }
  ];

  return (
    <section id="contact" className="contact">
      <div className="contact-container">
        <div className="contact-header" data-aos="fade-up">
          <h2 className="section-title">Let's Build Something Great Together</h2>
          <p className="section-subtitle">
            Have an idea? Need a website or app?<br />
            Get in touch with us — we'll take care of the rest.
          </p>
        </div>
        <div className="contact-buttons-grid">
          {contactMethods.map((method, index) => (
            <a
              key={index}
              href={method.link}
              target="_blank"
              rel="noopener noreferrer"
              className={`contact-button ${method.title.toLowerCase()}`}
              data-aos="zoom-in"
              data-aos-delay={100 + index * 100}
            >
              <div className="contact-icon">
                {method.icon}
              </div>
              <span>{method.buttonText}</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Contact;

